<template>
  <div class="eventComp_mode_16 eventComp_mode_container" v-show="currThemeObj">
    <div class="tableScrollArea" ref="tableParentDom">
      <el-tabs
        v-model="tabActiveKey"
        type="card"
        @tab-click="handleClickTab"
        v-if="groupTable && groupTable.length > 0"
      >
        <el-tab-pane
          :label="group.tabName"
          :name="group.tabKey"
          v-for="group in groupTable"
          :key="group.tabKey"
        >
          <mergeHeadCel_tablel
            v-if="mergeHeadKey.includes(group.tabName)"
            :currThemeObj="currThemeObj"
            :currCid="currCid"
            :currSid="currSid"
            :tableMode="tableMode"
            :columnColorPropArr="group.columnColorPropArr_greyBg"
            :columnColorPropArr_otherBg="group.columnColorPropArr_whiteBg"
            :textAlignleftPropArr="group.textAlignleftPropArr"
            :tableColumnData="group.tableColumnData"
            :tableData="group.tableData"
            v-show="group.tableData && group.tableData.length > 0"
          ></mergeHeadCel_tablel>
          <multiLevelFold_table
            v-else
            :currThemeObj="currThemeObj"
            :currCid="currCid"
            :currSid="currSid"
            :tableMode="tableMode"
            :parentWidthPx="parentWidthPx"
            :isScrollFlag="isScrollFlag"
            :variableColWidthVw="variableColWidthVw"
            :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
            :defaultWidthVwNum="group.defaultWidthVwNum"
            :tableColumnData="group.tableColumnData"
            :tableData="group.tableData"
            :expandKey="expandKey"
            :isExpandAll="isExpandAll"
            @toParentEvent="toParentEventHandler"
            v-show="group.tableData && group.tableData.length > 0"
          ></multiLevelFold_table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="note_box" v-show="annotationList && annotationList.length > 0">
      <span class="note_title" v-text="'注释'"></span>
      <span class="note_info">
        <span
          class="noteInfo_item"
          v-for="(item, index) in annotationList"
          :key="index"
          v-text="`${item.name}：${item.explain}`"
        ></span>
      </span>
    </div>
  </div>
</template>

<script>
// 适用： 表格上面带tab切换的 [不带展开行] [支持合并单元格 | 不合并单元格的] 体操 || 艺术体操
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import mergeHeadCel_tablel from '@components/platfromBase/compreSportsMeet/table/mergeHeadCel_tablel.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_16',
  components: {
    multiLevelFold_table,
    mergeHeadCel_tablel,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    tabType: {
      type: String, //确定数据来自于 出场名单'startList'  ||【 本场数据'localData' || 轮次成绩'roundResult' ||  单项成绩'singleResult' || 团体成绩 'teamResult' || 全能成绩'combinedResult'】,
      default: '',
    },
    competitorType: {
      type: String,
      default: '', // A || D || T
    },
    groupIndexStr: {
      type: String,
      default: '', // ['-1':没有分组, '-2':有分组且总的比赛进入赛果, '0':有分组且第一个分组比赛进入赛果]；有分组的比赛进入赛果传的都是总的比赛ID
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_16 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isScrollBottom: false,
      tableMode: 'eventComp_mode_16',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: 39.3,
      tableCellDefaultWidthVw: 5.55, //默认列的宽度决定了展开行箭头占得宽度，因此这个最好不要动；如果需要处理某个单独列的宽度时，单独赋值
      expandCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      annotationList: [],
      groupTable: [],
      expandKey: '',
      isExpandAll: false, //只要需要expand属性默认都是展开，这个只是控制显示的高度
      tabActiveKey: '',
      currModeObj: null,
      renderModeList: [
        {
          modeNameArr: [],
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['GRY'],
          resultKeyArr: ['result_unit', 'result_apparatus'],
          isCompetitorTypeArr: ['A', 'T'], //艺术体操分A和T；
          tabTypeArr: ['groupResult', 'singleResult'], // 艺术体操：【成绩|单项成绩】,这里面的 groupResult 对应的是艺术体操的成绩，singleResult 对应的是单人和团体；因为一个页面有2个带分组的tab
        },
        {
          modeNameArr: [],
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['GAR'],
          resultKeyArr: ['result_apparatus', 'result_apparatus'],
          isCompetitorTypeArr: ['A', 'T'], // 竞技体操
          tabTypeArr: ['groupResult', 'singleResult'], //体操只有男子团体和女子团体的单项成绩
        },
        {
          modeNameArr: [],
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['CSP'],
          resultKeyArr: ['result_apparatus'],
          isCompetitorTypeArr: ['A', 'D', 'T'], //皮划艇静水:  A | D | T
          tabTypeArr: ['groupResult'], // 皮划艇静水
        },
        {
          modeNameArr: [],
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['STK', 'CSP'],
          resultKeyArr: ['startList'],
          isCompetitorTypeArr: ['A-GP', 'D-GP', 'T-GP'], //皮划艇静水 分组 A-GP D-GP T-GP；
          tabTypeArr: ['startList'], // 出场名单
        },
        {
          modeNameArr: [],
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['BMX'],
          resultKeyArr: ['result_apparatus', 'startList'],
          isCompetitorTypeArr: ['A', 'A-GP'], //小轮车竞技 A|A-GP
          tabTypeArr: ['groupResult', 'startList'], // 小轮车竞技
        },
        {
          modeNameArr: [],
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['SBD', 'FRS', 'CTR'],
          resultKeyArr: ['result_apparatus'],
          isCompetitorTypeArr: ['A', 'D', 'T'], //场地自行车
          tabTypeArr: ['groupResult'], // 场地自行车
        },
        {
          modeNameArr: [],
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['SSK', 'CTR'],
          resultKeyArr: ['startList'],
          isCompetitorTypeArr: ['A-GP', 'D-GP', 'T-GP'], //场地自行车 分组 A-GP D-GP T-GP；
          tabTypeArr: ['startList'], // 场地自行车
        },
        {
          modeNameArr: [],
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['ATH', 'ATW', 'ATM'],
          resultKeyArr: ['result_apparatus', 'startList'],
          isCompetitorTypeArr: ['A', 'A-GP'], //田径 单人
          tabTypeArr: ['groupResult', 'startList'], // 田径
        },
        {
          modeNameArr: [],
          defaultInsertCustomColuIndex: 0, //在第0个后插入
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['STK', 'SSK', 'SBD', 'FRS', 'SMT', 'SWM', 'ROW', 'RCB'],
          resultKeyArr: ['startList'],
          isCompetitorTypeArr: ['A-GP'], //游泳|赛艇 分组 A-GP；
          tabTypeArr: ['startList'], // 出场名单
        },
      ],
      mergeHeadKey: ['跳马'], //体操里面的跳马项目单独处理，遇到这个项目切换成 合并单元格的表格
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.onResizeEvent()
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (
              modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId) &&
              modeItem.isCompetitorTypeArr.includes(this.competitorType)
            ) {
              this.currModeObj = modeItem
            }
          })
        }
        console.debug(
          'mode_16 this.currModeObj',
          this.currModeObj,
          this.tabType
        )
        if (this.currModeObj) {
          let i = this.currModeObj.tabTypeArr.indexOf(this.tabType)
          const formatData = JSON.parse(
            JSON.stringify(
              this.currModeObj.resultKeyArr[i] === 'startList'
                ? this.datas
                : this.datas[this.currModeObj.resultKeyArr[i]]
            )
          )
          console.debug(
            'mode_16 this.currModeObj',
            this.datas,
            i,
            this.currModeObj.resultKeyArr[i],
            formatData
          )
          if (formatData.annotation) {
            this.annotationList = formatData.annotation
          }
          this.computedModeData(formatData)
        }
        // if (this.currModeObj) {
        //   let i = this.currModeObj.isCompetitorTypeArr.indexOf(
        //     this.competitorType
        //   )
        //   let formatData = JSON.parse(
        //     JSON.stringify(
        //       this.currModeObj.resultKeyArr[i] === 'startList'
        //         ? this.datas
        //         : this.datas[this.currModeObj.resultKeyArr[i]]
        //     )
        //   )
        //   if (formatData.annotation) {
        //     this.annotationList = formatData.annotation
        //   }
        //   this.computedModeData(formatData)
        // }
      })
    },
    handleClickTab(tab, event) {
      console.debug(tab, event)
    },
    toParentEventHandler(data) {
      console.debug(data)
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedModeData(data) {
      console.debug('mode_16 computedModeData:', data)
      // const needAddEmptyColumnNameArr = ['运动员', '国家/地区'] //当table_head第一列的name属于其中之一，则要插入一个占位的空列
      if (data && data.result_data && data.result_data.length > 0) {
        this.groupTable = data.result_data.map((group) => {
          if (!group.group_code) {
            group.group_code = group.group_name || null
          }
          if (group.group_name) {
            if (this.mergeHeadKey.includes(group.group_name)) {
              return this.mergeComputedModeData(group)
            } else {
              let tableTotal = group.detail_list ? group.detail_list.length : 0
              const table_headArr = group.table_head
              let defaultWidthVwNum = 0
              let tableColumnData = []

              // 表头
              const headColumns = []
              let deletColumnNum = 0
              table_headArr.forEach((colums, colIndex) => {
                // if (colIndex === 0) {
                //   if (needAddEmptyColumnNameArr.includes(colums.name)) {
                //     // 当运动员排在第一列是，需要增加一列空的
                //     headColumns.push({
                //       colKey: 'ranking',
                //       colTitle: '',
                //     })
                //   }
                // }
                if (colums && colums.map_key_arr.length > 0) {
                  headColumns.push({
                    colKey: colums.map_key_arr[0] ? colums.map_key_arr[0] : '',
                    colTitle: colums.name ? colums.name : '',
                  })
                }
              })

              let customColumn = {}
              if (this.currModeObj.tableCellDefaultWidthVw) {
                this.tableCellDefaultWidthVw =
                  this.currModeObj.tableCellDefaultWidthVw
              }
              let widthVw = this.tableCellDefaultWidthVw
              const otherColumns = headColumns
              if (['A', 'D', 'A-GP', 'D-GP'].includes(this.competitorType)) {
                let prop = ''
                if (['A', 'A-GP'].includes(this.competitorType)) {
                  // 单人
                  // 体操 | 皮划艇静水
                  prop = 'playerName-playerLogo-playerGender-teamLogo-teamName'
                } else {
                  // 双人
                  // 皮划艇静水
                  prop = 'teamLogo-teamName-playerListString'
                }
                if (tableColumnData.length == 0) {
                  deletColumnNum++
                  customColumn = {
                    prop, //fristColumnPropArr.join('-'),
                    label: '运动员',
                    // widthVw:
                    //   this.currModeObj.variableColWidthVw[
                    //     this.currModeObj.sportsIdArr.indexOf(
                    //       this.currSportsDetail.sportsId
                    //     )
                    //   ], //对应列的宽度，单位vw
                    className: 'columnPlayerGroupClass', //单独定制的头部样式class
                    // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                  }
                }
              } else if (
                this.competitorType === 'T' ||
                ['T-GP'].includes(this.competitorType)
              ) {
                // 艺术体操 团体 || 皮划艇静水 团体 出场名单
                if (tableColumnData.length == 0) {
                  deletColumnNum++
                  customColumn = {
                    prop: 'teamLogo-teamName', //fristColumnPropArr.join('-'),
                    label: '国家/地区',
                    // widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                    className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
                    // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                  }
                }
              }

              for (let i = 0; i < otherColumns.length; i++) {
                const item = otherColumns[i]
                if (['运动员', '姓名', '国家/地区'].includes(item.colTitle)) {
                  // 特殊列
                  tableColumnData.push(customColumn)
                } else {
                  tableColumnData.push({
                    prop: item.colKey,
                    label: item.colTitle,
                    widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
                      ? this.expandCellDefaultWidthVw / 2
                      : widthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
                    className: ['arrowIcon', 'isExpand'].includes(item.colKey)
                      ? 'expandTdClassName'
                      : '', //单独定制的头部样式class
                    selected: '',
                  })
                }
              }
              defaultWidthVwNum = tableColumnData.length - deletColumnNum //减去这3列[teamLogo-teamName, arrowIcon, isExpand]
              console.debug('tableColumnData:', tableColumnData)

              let tableData = group.detail_list
                ? group.detail_list.map((rowData) => {
                    return rowData
                  })
                : []

              return {
                tabKey: group.group_code,
                tabName: group.group_name,
                tableData,
                tableColumnData,
                defaultWidthVwNum,
                tableTotal,
              }
            }
          } else {
            return {
              tabKey: 'undefinedKey',
              tabName: '未定义',
              tableData: [],
              tableColumnData: [],
              defaultWidthVwNum: 0,
              tableTotal: 0,
            }
          }
        })

        // if (this.groupTable.length > 0) {
        //   this.tabActiveKey = this.groupTable[0].tabKey
        // }
        if (this.groupTable.length > 0) {
          let actIndex = data.group_number ? data.group_number : 0 //分组的索引，从比赛列表第一次进入赛果读取比赛列表的索引，在赛果刷新读取赛果数据中的索引
          if (this.groupIndexStr && this.groupIndexStr - 0 >= 0) {
            actIndex = this.groupIndexStr
          }
          this.tabActiveKey = this.groupTable[actIndex].tabKey
          console.debug('actIndex:', actIndex, this.groupIndexStr, data)
        }

        // this.$refs.tableParentDom.scrollTo(0, 0)
        console.debug('this.groupTable:', this.groupTable)
      } else {
        console.debug('暂无数据')
        this.notDataHandler()
      }
    },
    mergeComputedModeData(data) {
      console.debug('computedModeData:', data)
      if (
        data &&
        data.detail_list &&
        data.table_head &&
        data.table_head.length > 0
      ) {
        let tableColumnData = []
        const mergKeyArr_greyBg = [
          '组',
          '立姿淘汰赛',
          '秒',
          '第二阶段',
          '第二跳',
        ]
        let columnColorPropArr_greyBg = []
        const mergKeyArr_whiteBg = ['第一阶段', '第一跳']
        let columnColorPropArr_whiteBg = []
        // 只给跳马用的
        data.table_head.forEach((column) => {
          if (column.map_key_arr.length === 1) {
            let prop = column.map_key_arr[0]
            tableColumnData.push({
              prop: prop,
              id: prop,
              label: column.name,
              widthVw: 6.25,
            })
          }
          if (column.name === '运动员') {
            tableColumnData.push({
              prop: 'playerName-playerLogo-playerGender-teamLogo-teamName',
              id: 'player_name',
              label: '运动员',
              //   widthVw: 25.42, //对应列的宽度，单位vw
              //   widthPx: Math.floor(25.42 * this.vw2px),
              className: 'columnTextLeftClass', //单独定制的头部样式class
              // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
            })
          }
          if (mergKeyArr_greyBg.includes(column.name)) {
            columnColorPropArr_greyBg = [].concat(
              columnColorPropArr_greyBg,
              column.map_key_arr
            )
            let child = column.map_key_arr.map((rowCeil) => {
              return {
                prop: rowCeil,
                label: rowCeil.split('-')[1],
                widthVw: 4.16,
                className: 'columnHightBgClass',
              }
            })
            tableColumnData.push({
              prop: '',
              id: `totalGroup_${mergKeyArr_greyBg.indexOf(column.name)}`,
              label: column.name,
              child,
            })
          }

          if (mergKeyArr_whiteBg.includes(column.name)) {
            columnColorPropArr_whiteBg = [].concat(
              columnColorPropArr_whiteBg,
              column.map_key_arr
            )
            let child = column.map_key_arr.map((rowCeil) => {
              return {
                prop: rowCeil,
                label: rowCeil.split('-')[1],
                widthVw: 3.75,
                className: 'columnHightBgClass',
              }
            })
            tableColumnData.push({
              prop: '',
              id: `totalGroup_${mergKeyArr_whiteBg.indexOf(column.name)}`,
              label: column.name,
              child,
            })
          }
        })

        console.debug('tableColumnData:', tableColumnData)

        let tableData = data.detail_list.map((rowData) => {
          tableColumnData.forEach((columnItem) => {
            if (columnItem.widthVw) {
              columnItem.widthPx = Math.floor(columnItem.widthVw * this.vw2px)
            }

            if (columnItem.child) {
              columnItem.child.forEach((childItem) => {
                if (childItem.widthVw) {
                  childItem.widthPx = Math.floor(childItem.widthVw * this.vw2px)
                }
                if (columnItem.isAssignFlag) {
                  console.debug('columnItem:', columnItem)
                  if (childItem.originVal.length > 1) {
                    let originValArr = []
                    childItem.originVal.forEach((originItem) => {
                      originValArr.push(rowData[originItem])
                    })
                    rowData[childItem.prop] = originValArr.join('/')
                  } else {
                    rowData[childItem.prop] = rowData[childItem.originVal[0]]
                  }
                }
              })
            } else {
              if (columnItem.isAssignFlag) {
                rowData[columnItem.prop] = rowData[columnItem.originVal[0]]
              }
            }
          })
          // this.columnColorPropArr_greyBg.forEach
          return rowData
        })
        console.debug('this.tableData:', tableData)
        return {
          tabKey: data.group_code,
          tabName: data.group_name,
          tableData,
          tableColumnData,
          columnColorPropArr_greyBg,
          columnColorPropArr_whiteBg,
          textAlignleftPropArr: ['player_name'],
          tableTotal: tableData && tableData.length > 0 ? tableData.length : 0,
        }
      } else {
        return {
          tabKey: 'undefinedKey',
          tabName: '未定义',
          tableData: [],
          tableColumnData: [],
          columnColorPropArr_greyBg: [],
          columnColorPropArr_whiteBg: [],
          textAlignleftPropArr: [],
          tableTotal: 0,
        }
      }
    },
    notDataHandler() {
      this.groupTable = []
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  .tableScrollArea {
    position: relative;
    width: 100%;
  }
  .note_box {
    width: 100%;
    padding: 0.694vw 1.338vw 4.16vw;
    /* border-top: 1px solid var(--mixtmt_greyColor8); */
    .note_title {
      display: block;
      font-size: 1.11vw;
      color: var(--mixtmt_mainColor);
      line-height: 2.083vw;
      font-weight: bold;
    }
    .note_info {
      width: 100%;
      padding: 0 0.694vw 0 0;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .noteInfo_item {
        width: auto;
        min-width: 12.5%;
        text-align: left;
        font-size: 1.11vw;
        line-height: 2.5vw;
        color: var(--mixtmt_greyColor2);
        padding-left: 1.388vw;
        &:first-child {
          padding-left: 0.694vw;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.mixtmt_pc {
  .eventComp_mode_container {
    .el-tabs__item:hover {
      cursor: pointer;
    }
  }
}
.eventComp_mode_container {
  .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border-radius: 0.416vw 0.416vw 0 0;
    border-color: var(--mixtmt_table_headerBg);
    overflow: hidden;
  }
  .el-tabs__item {
    padding: 0 1.388vw;
    height: 2.788vw;
    line-height: 2.788vw;
    font-size: 1.11vw;
    min-width: 6.94vw;
    text-align: center;
    color: var(--mixtmt_greyColor6);
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item {
    transition: none;
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item {
    border-left: 1px solid var(--mixtmt_table_headerBg);
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item:first-child {
    border-left: none;
  }
  .el-tabs__header {
    margin: 0;
  }
  .el-tabs__item.is-active,
  .el-tabs__item.is-active:hover,
  .el-tabs__item:hover {
    background-color: var(--mixtmt_table_headerBg);
    color: var(--mixtmt_table_headerColor);
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-color: var(--mixtmt_table_headerBg);
  }

  .el-tabs--bottom
    .el-tabs--left
    > .el-tabs__header
    .el-tabs__item:nth-child(2),
  .el-tabs--bottom
    .el-tabs--right
    > .el-tabs__header
    .el-tabs__item:nth-child(2),
  .el-tabs--bottom.el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item:nth-child(2),
  .el-tabs--bottom.el-tabs--card > .el-tabs__header .el-tabs__item:nth-child(2),
  .el-tabs--top .el-tabs--left > .el-tabs__header .el-tabs__item:nth-child(2),
  .el-tabs--top .el-tabs--right > .el-tabs__header .el-tabs__item:nth-child(2),
  .el-tabs--top.el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item:nth-child(2),
  .el-tabs--top.el-tabs--card > .el-tabs__header .el-tabs__item:nth-child(2) {
    padding-left: 1.388vw;
  }
  .el-cascader-menu:last-child .el-cascader-node,
  .el-tabs--bottom .el-tabs--left > .el-tabs__header .el-tabs__item:last-child,
  .el-tabs--bottom .el-tabs--right > .el-tabs__header .el-tabs__item:last-child,
  .el-tabs--bottom.el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item:last-child,
  .el-tabs--bottom.el-tabs--card > .el-tabs__header .el-tabs__item:last-child,
  .el-tabs--top .el-tabs--left > .el-tabs__header .el-tabs__item:last-child,
  .el-tabs--top .el-tabs--right > .el-tabs__header .el-tabs__item:last-child,
  .el-tabs--top.el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item:last-child,
  .el-tabs--top.el-tabs--card > .el-tabs__header .el-tabs__item:last-child {
    padding-right: 1.388vw;
  }
}
</style>
